module.exports = __webpack_public_path__ + "static/media/FLNSCren.15cfa566.png";